import { RecalculatePriceStrategy } from '../types';
import {
  noOpQuantityChange,
  noOpQuotePriceCreation,
  noOpUnitPrice,
} from './no-op';

export const recalculateUserImport = {
  onQuantityChange: noOpQuantityChange,
  onUnitPriceChange: noOpUnitPrice,
  onGrossMarginChange: null,
  onBaseGrossMarginChange: null,
  onContributionMarginChange: null,
  onQuotePriceCreation: noOpQuotePriceCreation,
  onUnitCostChange: null,
} satisfies RecalculatePriceStrategy;
